const MAIN_URL = process.env.NEXT_PUBLIC_MAIN_URL || 'https://example.com';
const APP_URL = process.env.NEXT_PUBLIC_APP_URL || 'https://example.com';

export const ROUTES = {
    HOME :`${MAIN_URL}`,
    APPLY_FOR_AFFILIATE: `${MAIN_URL}/apply-for-affiliate-program`,
    APPLY_FOR_STUDENT_DISCOUNT: `${MAIN_URL}/apply-for-student-discount`,
    TERMS_OF_USE: `${MAIN_URL}/terms-of-use`,
    THANK_YOU: `${MAIN_URL}/thank-you`,

    REGISTRATION: `${APP_URL}/registration`,
    PRICING: `${APP_URL}/pricing`,
    DASHBOARD: `${APP_URL}/dashboard/recommendations`,
    PROFILE_SETTING: `${APP_URL}/setting/profile-setting`,
    SUBSCRIPTION_THANK_YOU: `${APP_URL}/subscription-received/thank-you`,

    dynamic: {
        Profile: (slug: string) => `${APP_URL}/cr/${slug}`,
        Section: (slug: string, section: string) => `${APP_URL}/cr/${slug}/${section}`,
    },
};

export default ROUTES;
